// Separate dispatch helper to avoid circular dependencies
// This file should NOT import from store.ts or rootReducer.ts

type DispatchFn = (action: any) => any;

let _dispatch: DispatchFn | null = null;

export function setDispatchFn(dispatch: DispatchFn) {
  _dispatch = dispatch;
}

export function getDispatch(): DispatchFn {
  if (!_dispatch) {
    throw new Error('Dispatch not initialized. Make sure store is created first.');
  }
  return _dispatch;
}
